export default (theme) => ({
  container: {
    padding: 5,
  },
  input: {
    border: "solid 1px rgba(155,155,155)",
    borderRadius: 4,
    padding: "0px 4px",
  },
});
